import firebase from 'firebase';

export async function addFileToTmp(fileInfo) {
    const { fileType, procedureId, lang, storagePath, downloadUrl, fileName } = fileInfo;
    
    const tmpDocRef = firebase.firestore().collection("tmp").doc(procedureId);
    
    let fieldName;
    if (lang) {
        switch(fileType) {
            case 'video_demo_files':
                fieldName = `demoUrl_${lang}`;
                break;
            case 'video_files':
                fieldName = `videoUrl_${lang}`;
                break;
            case 'guide_files':
                fieldName = `fascicleUrl_${lang}`;
                break;
            case 'image_preview_files':
                fieldName = `previewUrl_${lang}`;
                break;
            default:
                fieldName = `${fileType}_${lang}`;
        }
    } else {
        switch(fileType) {
            case 'video_demo_files':
                fieldName = 'demoUrl';
                break;
            case 'video_files':
                fieldName = 'videoUrl';
                break;
            case 'guide_files':
                fieldName = 'fascicleUrl';
                break;
            case 'image_preview_files':
                fieldName = 'previewUrl';
                break;
            default:
                fieldName = fileType;
        }
    }
    
    const updateData = {
        [fieldName]: downloadUrl,
        [`${fieldName}_path`]: storagePath,
        [`${fieldName}_fileName`]: fileName
    };
    
    await tmpDocRef.set(updateData, { merge: true });
    
    return { fieldName, downloadUrl, storagePath, fileName };
}

export async function removeTmpForProcedure(procedureId) {
    const tmpDocRef = firebase.firestore().collection("tmp").doc(procedureId);
    await tmpDocRef.delete();
}

export function uploadFileToStorage(collection, docID, fileName, file, loadingText, setState) {
    return new Promise((resolve, reject) => {
        let storagePath = getStoragePath(collection, docID, fileName)
        let storageRef = firebase.storage().ref().child(storagePath)
        let uploadPreviewTask = storageRef.put(file)

        uploadPreviewTask.on("state_changed",
            (snapshot) => {
                const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                const fileStatus = { name: loadingText, state: progress };
                setState({ fileStatus, fileModalShow: true });
                console.log(`FILE STATUS ${loadingText}: ${fileStatus}`);
            },
            (error) => {
                console.log(`Error al subir ${loadingText}, a storage: ${JSON.stringify(error)}`);
                reject(error)
            },
            async () => {
                let url = await uploadPreviewTask.snapshot.ref.getDownloadURL()
                setState({ fileModalShow: false });
                resolve({ url, storagePath })
            }
        );
    })
}

function getStoragePath(coll, docID, fileName,) {
    if (storagePathContains_DocID(coll))
        return `${coll}/${docID}/${fileName}`
    return `${coll}/${fileName}`
}
const storagePathContains_DocID = (collection) => ["aulas", "diplomados", "organizations"].includes(collection)

export function uploadTranslationFileToStorage(procedureID, lang, fileName, file, loadingText, setState) {
    return new Promise((resolve, reject) => {
        const storagePath = `procedures_translations/${procedureID}/${lang}/${fileName}`;
        const storageRef = firebase.storage().ref().child(storagePath);
        const uploadTask = storageRef.put(file);

        uploadTask.on("state_changed",
            (snapshot) => {
                const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                const fileStatus = { name: loadingText, state: progress };
                setState({ fileStatus, fileModalShow: true });
                console.log(`FILE STATUS ${loadingText}: ${fileStatus}`);
            },
            (error) => {
                console.log(`Error al subir ${loadingText} a storage: ${JSON.stringify(error)}`);
                reject(error);
            },
            async () => {
                const url = await uploadTask.snapshot.ref.getDownloadURL();
                setState({ fileModalShow: false });
                resolve({ url, storagePath });
            }
        );
    });
}